<template>
  <div class="p-3">
    <filtro ref="filtro" @buscar="buscar" />
    <form-modal
      id="anexo2"
      placeholder-button="Inserir"
      :title-modal="titulo"
      :fields="colunas"
      :values="dados"
      ref="modalForm"
      read
      update
      remove
      controles
      hide-button
      :somente-ok="componente == 'detalhes'"
      :ok-cancel="componente == 'detalhes'"
      @ok="salvar"
      @edit="editar"
      @remove="deletar"
      @cancel="fechar"
    >
      <template #modal>
        <component
          :is="componente"
          :id-anexo="idAnexo2"
          :empresa-id="empresaId"
          :form="form"
          ref="modal"
        />
      </template>
      <template #table>
        <div class="table-responsive">
          <b-table
            head-variant="dark"
            :fields="colunas"
            :items="dados"
            @row-dblclicked="abrir"
          >
            <template #cell(somatoriaValoresDebitados)="data">
              <div class="d-flex align-items-center">
                {{ data.value }}
                <b-button
                  @click="abrirValoresDebitados(data.item)"
                  v-if="permissao.u"
                  class="ml-2"
                  variant="flat-info"
                >
                  <i class="fas fa-plus"></i>
                </b-button>
              </div>
            </template>

            <template #cell(taxaSelic)="data">
              <div class="d-flex align-items-center justify-content-between">
                <span v-if="!data.item.editando">
                  {{ data.value.toFixed(5) }}
                </span>

                <input-text
                  type="number"
                  :min="0"
                  :max="100"
                  style="width: 100px"
                  v-model="formSelic.taxa"
                  v-if="data.item.editando"
                />

                <b-button
                  v-if="data.item.editando"
                  @click="salvarSelic"
                  variant="flat-success"
                  class="ml-2"
                >
                  <i class="fas fa-check"></i>
                </b-button>
                <b-button
                  v-if="data.item.editando"
                  @click="editarSelic(data.item, false)"
                  variant="flat-danger"
                  class="ml-2"
                >
                  <i class="fas fa-close"></i>
                </b-button>
                <b-button
                  v-if="!data.item.editando && permissaoSelic.u"
                  @click="editarSelic(data.item, true)"
                  variant="flat-primary"
                  class="ml-2"
                >
                  <i class="fas fa-edit"></i>
                </b-button>
              </div>
            </template>

            <template #cell(actions)="data">
              <div class="d-flex">
                <b-button
                  @click="abrir(data.item)"
                  v-if="permissao.u"
                  variant="flat-primary"
                >
                  <i class="fa-solid fa-search"></i>
                </b-button>
              </div>
            </template>
          </b-table>
        </div>
      </template>
    </form-modal>
  </div>
</template>
<script>
import FormModal from "@/components/modal/FormModal";
import cloneDeep from "lodash/cloneDeep";
import MovimentacaoFinanceiraService from "@/common/services/movimentacao_financeira/movimentacao_financeira.service";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";
import helpers from "@/common/utils/helpers";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import Filtro from "../Filtro";
import InputText from "@/components/inputs/InputText";

export default {
  mixins: [AlertasMixin],
  components: {
    FormModal,
    Filtro,
    "valores-debitados": () => import("./valores_debitados"),
    detalhes: () => import("./detalhes"),
    InputText,
  },
  props: {
    empresaId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    componente: "valores-debitados",
    titulo: "",
    form: {},
    colunas: [
      { key: "ano", label: "Ano" },
      {
        key: "mes",
        label: "Mês",
        formatter: (valor) => {
          return valor == "Marco" ? "Março" : valor;
        },
      },
      { key: "rol", label: "ROL", formatter: (value) => helpers.formatarValor(value) },
      { key: "pd", label: "P&D", formatter: (value) => helpers.formatarValor(value) },
      {
        key: "lancamentosRegraAntiga",
        label: "Lançamentos RN 219 (Regra antiga)",
        formatter: (value) => helpers.formatarValor(value),
      },
      {
        key: "lancamentosRegraNova",
        label: "Lançamentos RN 316 (Regra nova)",
        formatter: (value) => helpers.formatarValor(value),
      },
      {
        key: "saldoAcumuladoServicoEmCurso",
        label: "Saldo acumulado de serviços em curso",
        formatter: (value) => {
          return helpers.formatarValor(value);
        },
      },
      { key: "taxaSelic", label: "Taxa SELIC (%)" },
      {
        key: "remuneracaoSELIC",
        label: "Remuneração SELIC (R$)",
        formatter: (value) => helpers.formatarValor(value),
      },
      {
        key: "aplicacaoNONECE",
        label: "Valor investido (NO,NE,CE)",
        formatter: (value) => helpers.formatarValor(value),
      },
      {
        key: "saldo",
        label: "Saldo (R$)",
        formatter: (value) => helpers.formatarValor(value),
      },
      {
        key: "somatoriaValoresDebitados",
        label: "Projetos encerrados",
        formatter: (value) => helpers.formatarValor(value),
      },
      {
        key: "actions",
        label: "Ações",
      },
    ],
    dados: [],
    idAnexo2: "",
    projetos: [],
    formSelic: {},
  }),
  mounted() {
    //this.buscar();
  },
  methods: {
    salvarSelic() {
      let form = cloneDeep(this.formSelic);

      this.confirmar("Aviso", "Deseja salvar?").then((confirmado) => {
        if (confirmado) {
          form.EmpresaId = this.empresaId;

          this.$store.dispatch(START_LOADING);
          MovimentacaoFinanceiraService.salvarSelic(form)
            .then(() => {
              this.alertaSucesso("Taxa selic salva com sucesso!").then(() => {
                this.$refs["filtro"].buscar();
              });
            })
            .catch((err) => {
              if (err.response.status == 400) {
                this.alertaErro(err.response.data.errors);
              } else this.alertaErro("Erro ao salvar taxa selic");
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        }
      });
    },
    editarSelic(item, editando) {
      this.dados.forEach((element) => {
        element.editando = false;
      });
      let ano = item.ano;
      let mes = helpers.retornarIndiceMes(item.mes);

      if (editando) {
        this.$store.dispatch(START_LOADING);
        this.buscarSelic(ano, mes)
          .then(() => {
            item.editando = true;
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      } else {
        item.editando = false;
      }
    },
    buscarSelic(ano, mes) {
      return new Promise((resolve, reject) => {
        MovimentacaoFinanceiraService.listarSelic(this.empresaId, ano, ano, mes, mes)
          .then((response) => {
            let dados = response.data.data.map((el) => {
              el.taxa = el.taxa.toFixed(5);
              return el;
            });
            if (dados.length > 0) {
              this.formSelic = dados[0];
              resolve();
            } else {
              this.buscarTaxaSelic(ano, mes).then((res) => {
                this.formSelic = {
                  ano: ano,
                  mes: mes,
                  taxa: res,
                };
                resolve();
              });
            }
          })
          .catch(() => {
            reject();
          });
      });
    },
    buscarTaxaSelic(ano, mes) {
      return new Promise((resolve) => {
        MovimentacaoFinanceiraService.buscarFatorAcumulado(mes, ano)
          .then((res) => {
            resolve(res.data.data.taxa);
          })
          .catch(() => {
            resolve(0);
          });
      });
    },
    montar: function () {
      this.$refs["filtro"].montar();
    },
    fechar: function () {
      this.$refs["filtro"].buscar();
    },
    abrir: function (item) {
      this.titulo = `DETALHAMENTO ANEXO 2 - (${item.mes}/${item.ano})`;
      this.componente = "detalhes";
      let form = cloneDeep(item);
      this.form = [form];

      this.$refs.modalForm.openModal();
    },
    inicializarProjetosRN219() {
      this.form = {
        titulo: "",
        codigo: "",
        ano_inicio: "",
        ano_fim: "",
        desembolsos: [],
        custos: [],
      };
    },
    abrirValoresDebitados(item) {
      this.form = cloneDeep(item.valoresDebitados);
      this.form = this.form.map((el) => {
        el.projetoObj = el.projetoId || el.projetoGestaoId;
        el.valor = helpers.formatarValor(el.valor);
        return el;
      });

      this.idAnexo2 = item.id;
      this.componente = "valores-debitados";
      this.titulo = "Projetos encerrados";
      this.$refs.modalForm.openModal();
    },

    buscarProjetos: function () {
      this.projetos = [];
      MovimentacaoFinanceiraService.listarProjetos(this.idAnexo2).then((res) => {
        this.projetos = res.data.data.map((el) => {
          return {
            value: el.projetoGestaoId || el.projetoId,
            text: "",
            el: el,
          };
        });
      });
    },

    salvarValoresDebitados: function () {
      this.form.forEach((element) => {
        let form = cloneDeep(element);
        form.valor = helpers.removerValor(form.valor);
        form.anexo2Id = this.idAnexo2;
        let projeto = this.projetos.find((el) => el.value == form.projetoObj).el;
        form.projetoGestaoId = projeto.projetoGestaoId;
        form.projetoId = projeto.projetoId;

        MovimentacaoFinanceiraService.salvarValoresDebitados(form)
          .then((res) => {
            if (!element.id) element.id = res.data.data;
            this.toast("Salvo com sucesso!", { variant: "success" });
          })
          .catch((err) => {
            if (err.response.status == 400) {
              this.toast(err.response.data.errors, { variant: "danger" });
            } else this.toast("Erro ao salvar", { variant: "danger" });
          })
          .finally(() => {});
      });
    },
    salvar: function () {
      if (!this.$refs.modal.validateState()) return;

      this.confirmar("Aviso", "Deseja salvar?").then((confirmado) => {
        if (confirmado) {
          if (this.componente == "valores-debitados") this.salvarValoresDebitados();
          else if (this.componente == "projetos-rn219") this.salvarProjetosRN219();
        }
      });
    },

    deletar: function (item) {
      this.confirmar("Aviso", "Deseja realmente excluir?").then((confirmado) => {
        if (confirmado) {
          this.$store.dispatch(START_LOADING);
          MovimentacaoFinanceiraService.deletarSelic(item.id)
            .then(() => {
              this.alertaSucesso("Excluído com sucesso!");
              this.buscar();
            })
            .catch((err) => {
              if (err.response.status == 400) {
                this.alertaErro(err.response.data.errors);
              } else this.alertaErro("Erro ao excluir");
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        }
      });
    },

    editar: function (item) {
      let form = cloneDeep(item);
      this.form = form;
      this.form.receitas.map((el) => {
        el.valor = helpers.formatarValor(el.valor);
        return el;
      });
      this.form.deducoes.map((el) => {
        el.valor = helpers.formatarValor(el.valor);
        return el;
      });
      this.$refs.modalForm.openModal();
    },

    buscar: function (filtro) {
      this.$store.dispatch(START_LOADING);
      MovimentacaoFinanceiraService.listarAnexo2(
        this.empresaId,
        filtro.ano,
        filtro.anoFim,
        filtro.mesInicio,
        filtro.mesFim
      )
        .then((response) => {
          this.dados = response.data.data.map((el) => {
            el.editando = false;
            return el;
          });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
  watch: {
    idAnexo2: function (valor) {
      if (valor) {
        this.buscarProjetos();
      }
    },
  },
  computed: {
    permissao() {
      return this.$store.getters["app/retornaPermissao"]("MovimentacaoFinanceiraAnexo2");
    },
    permissaoSelic() {
      return this.$store.getters["app/retornaPermissao"]("MovimentacaoFinanceiraSelic");
    },
  },
};
</script>
<style lang=""></style>
